import React, { useCallback } from 'react';
import { useSessionStorage } from 'react-use';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Icon } from '../../../concepts/resources/Icon';
import { Cell, Colors, Grid } from '../../../ui';
import { DropButton } from '../../../ui/DropButton';
import { NativeSelect } from '../../../ui/NativeSelect';
import { useResolve } from '../../Container';
import { InlineWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { flexLayoutInArea } from './AutoLayoutCommands';
import { AutoLayoutSortOptions } from './AutoLayoutSortOptions';
import { FlexLayoutConfig } from './FlexLayout';
import { FlexLayoutConfigLabel, FlexLayoutConfigWidget } from './FlexLayoutConfigWidget';

export const AutoLayoutToolWidget = ({ widget }: { widget: InlineWidget }) => {

    const dispatch = useResolve(CommandDispatcher);
    const { from, to } = widget;
    const [config, setConfig] = useSessionStorage('deqo/ui/autoLayoutTool', ['row', 'start', 'start', 10] as FlexLayoutConfig);
    const [sort, setSort] = useSessionStorage('deqo/ui/autoLayoutTool/sort', [AutoLayoutSortOptions[0].value, 'asc' as 'asc' | 'desc'] as const);

    const onChangeConfig = useCallback((nextConfig: FlexLayoutConfig) => {
        widget.update({ config: nextConfig });
        setConfig(nextConfig);
        dispatch(flexLayoutInArea, [from, to, ...nextConfig, sort.join(':')]);
    }, [config, sort]);

    const onChangeSortBy = useCallback((nextSortBy: string) => {
        const nextSort = [nextSortBy, sort[1]] as const;
        dispatch(flexLayoutInArea, [from, to, ...config, nextSort.join(':')]);
        setSort(nextSort);
    }, [config, sort]);

    const onToggleSortOrder = useCallback(() => {
        const nextSortOrder = sort[1] === 'asc' ? 'desc' : 'asc';
        const nextSort = [sort[0], nextSortOrder] as const;
        dispatch(flexLayoutInArea, [from, to, ...config, nextSort.join(':')]);
        setSort(nextSort);
    }, [config, sort]);

    return <Flexer padding=".25">
        <Grid columns="4rem repeat(3, 1fr)" rowGap=".5" columnGap=".5">
            <FlexLayoutConfigWidget value={config} onChange={onChangeConfig} />
            <FlexLayoutConfigLabel label="Sort" />
            <Cell width={3}>
                <Grid columns="1fr 2rem" columnGap='.25'>
                    <NativeSelect options={AutoLayoutSortOptions} value={sort[0]} onSelect={onChangeSortBy} />
                    <DropButton overflow="0" padding="0" onClick={onToggleSortOrder}>
                        <Icon color={Colors.primaryText} size="1.25" src={`deqo://icons/hero/arrow-${sort[1] === 'desc' ? 'up' : 'down'}`} />
                    </DropButton>
                </Grid>
            </Cell>
        </Grid>
    </Flexer>;
};
